/* ==========================================================================
   KEFIT — Search bar placeholder typewriter
   Self-contained. Animates the native `placeholder` attribute of any
   .kefit-search__input found inside an element carrying
   [data-kefit-typewriter="brand1, brand2, ..."].
   Pauses automatically while the field is focused or has a value.
   ========================================================================== */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function startTypewriter(input, words) {
    if (!words.length) return;

    var prefix = window.kefitT ? window.kefitT('search_for', 'Search for ') : 'Search for ';
    var wordIndex = 0;
    var charIndex = 0;
    var deleting = false;

    var typeSpeed = 90;    /* ms per letter while typing */
    var deleteSpeed = 45;  /* ms per letter while erasing */
    var holdTime = 1400;   /* pause once fully typed */
    var betweenTime = 400; /* pause once fully erased, before next word */

    function isUserActive() {
      return document.activeElement === input || input.value.length > 0;
    }

    function tick() {
      if (isUserActive()) {
        window.setTimeout(tick, 300); /* keep checking, don't reset progress */
        return;
      }

      var word = words[wordIndex];
      var delay = typeSpeed;

      if (!deleting) {
        charIndex++;
        input.setAttribute('placeholder', prefix + word.slice(0, charIndex));
        if (charIndex === word.length) {
          deleting = true;
          delay = holdTime;
        }
      } else {
        charIndex--;
        input.setAttribute('placeholder', prefix + word.slice(0, charIndex));
        delay = deleteSpeed;
        if (charIndex === 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          delay = betweenTime;
        }
      }

      window.setTimeout(tick, delay);
    }

    input.setAttribute('placeholder', prefix);
    window.setTimeout(tick, betweenTime);
  }

  ready(function () {
    document.querySelectorAll('[data-kefit-typewriter]').forEach(function (wrapper) {
      var raw = wrapper.getAttribute('data-kefit-typewriter') || '';
      var words = raw.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var input = wrapper.querySelector('.kefit-search__input');
      if (input) startTypewriter(input, words);
    });
  });
})();